module.exports = __webpack_public_path__ + "static/media/big-sabard.2bce3021.jpg";